import React, { useState } from 'react';
import { ShoppingCart, Package, ClipboardCheck, DollarSign } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSaleCreation } from '../../../../features/sales/create/hooks/useSaleCreation';
import LotReviewModal from '../modals/LotReviewModal';
import ConstructionModal from '../../../shared/modals/ConstructionModal';

const QuickActions = ({ lot }) => {
  const navigate = useNavigate();
  const { handleSaleItemAdded } = useSaleCreation();
  const [showReviewModal, setShowReviewModal] = useState(false);
  // Estado para el modal de construcción
  const [showConstructionModal, setShowConstructionModal] = useState(false);
  const [constructionModalConfig, setConstructionModalConfig] = useState({
    title: "¡En Construcción!",
    message: "Estamos trabajando para implementar esta funcionalidad. ¡Muy pronto disponible!",
    buttonText: "Entendido"
  });

  const handleNewSale = () => {
    // Crear el item de venta con los datos del lote actual
    const saleItem = {
      lotId: lot.id,
      title: lot.title,
      quantity: 1,
      unit: lot.unit,
      unitPrice: lot.unitPrice || 0,
      deposit: 0,
      subtotal: lot.unitPrice || 0,
      totalDeposit: 0
    };
    
    // Agregar el item y navegar a la pantalla de revisión
    handleSaleItemAdded(saleItem);
  };
  
  const handleCountStock = () => {
    // Mostrar modal de construcción para Contar Stock
    setConstructionModalConfig({
      title: "Conteo de Stock",
      message: "La funcionalidad de conteo de stock estará disponible próximamente. ¡Gracias por tu paciencia!",
      buttonText: "Volver"
    });
    setShowConstructionModal(true);
  };

  const handleReview = () => {
    // Mostrar modal de construcción para Repaso en todos los casos
    setConstructionModalConfig({
      title: "Repaso de Lote",
      message: "La funcionalidad de repaso de lotes está siendo mejorada. ¡Pronto tendrás acceso a una versión optimizada!",
      buttonText: "Volver"
    });
    setShowConstructionModal(true);
  };

  return (
    <>
      <div className="grid grid-cols-3 gap-3 p-5 bg-white dark:bg-gray-800">
        {/* Botón de Nueva Venta con estilo destacado */}
        <button 
          onClick={handleNewSale}
          className="flex items-center justify-center gap-2 px-4 py-3.5 bg-[#2C6859] dark:bg-[#245347] text-white rounded-lg hover:bg-[#245347] dark:hover:bg-[#1A3D34] transition-colors border border-[#2C6859]/80 dark:border-[#245347]/80 shadow-sm"
        >
          <DollarSign className="w-5 h-5" />
          <span className="font-bold">Nueva Venta</span>
        </button>
        
        {/* Botón de Contar Stock */}
        <button 
          onClick={handleCountStock}
          className="flex items-center justify-center gap-2 px-4 py-3.5 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors border border-gray-200 dark:border-gray-600 shadow-sm"
        >
          <Package className="w-5 h-5" />
          <span className="font-medium">Contar Stock</span>
        </button>
        
        {/* Botón de Repaso */}
        <button 
          onClick={handleReview}
          className="flex items-center justify-center gap-2 px-4 py-3.5 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors border border-gray-200 dark:border-gray-600 shadow-sm"
        >
          <ClipboardCheck className="w-5 h-5" />
          <span className="font-medium">Repaso</span>
        </button>
      </div>

      {/* Modal de Repaso */}
      {showReviewModal && (
        <LotReviewModal
          lot={lot}
          onClose={() => setShowReviewModal(false)}
        />
      )}
      
      {/* Modal de Construcción */}
      <ConstructionModal
        isOpen={showConstructionModal}
        onClose={() => setShowConstructionModal(false)}
        title={constructionModalConfig.title}
        message={constructionModalConfig.message}
        buttonText={constructionModalConfig.buttonText}
      />
    </>
  );
};

export default QuickActions; 